module.exports = __webpack_public_path__ + "img/empty_state_recommended.2eb699b5.svg";